import React from 'react';
import { getSanityClient } from '../../tools/sanity';
import PortraitCarousel, { PortraitCarouselProps } from './PortraitCarousel';

const Renderer = (props: PortraitCarouselProps) => <PortraitCarousel {...props} reference />;

const cmsLoader = async (data, requirement) => {
  const query = `*[${data.slides.map((s) => `_id=="${s._ref}"`).join(' || ')}]`;
  const client = getSanityClient(requirement);
  data.slides = await client.fetch(query);

  return data;
};

const PortraitCarouselRef = { Renderer, cmsLoader };

export { Renderer, cmsLoader };
export default PortraitCarouselRef;
